import Tooltip from "bootstrap/js/dist/tooltip";
import {Modal, Popover} from "bootstrap";

window.addEventListener('load', () => {
    const selectElements = document.querySelectorAll('.form-select') as NodeListOf<HTMLSelectElement>;
    if (selectElements.length) {
        selectElements.forEach((selectElement) => {
            const setSelectElementClass = (element) => {
                element.classList.add('text-secondary');
                if (element.value !== '') {
                    element.classList.remove('text-secondary');
                }
            }

            selectElement.addEventListener('change', () => setSelectElementClass(selectElement));
            setSelectElementClass(selectElement);
        });
    }
});

window.addEventListener("beforeunload", (event) => {
    (document.querySelectorAll("[type=submit]") as NodeListOf<HTMLButtonElement>).forEach((submit) => {
        submit.disabled = true;
    });
    setTimeout(() => {
        (document.querySelectorAll("[type=submit]") as NodeListOf<HTMLButtonElement>).forEach((submit) => {
            submit.disabled = false;
        });
    }, 2000)
});

export function stopEvent(event) {
    event.stopImmediatePropagation();
    event.stopPropagation();
    event.preventDefault();
    return false;
}

if (!(window as any).modals) {
    (window as any).modals = [];
}

(window as any).openModal = openModal;
export function openModal(id) {
    if (!(window.modals[id])) {
        let modal_element = document.getElementById(id) as HTMLElement;
        window.modals[id] = new Modal(modal_element);
        modal_element.addEventListener('hidden.bs.modal', function () {
            closeModal(id);
        })
    }
    window.modals[id].show();
}

(window as any).closeModal = closeModal;
export function closeModal(id) {
    window.modals[id].hide();
    /**@ts-ignore */
    window.modals[id]._element.querySelectorAll("form").forEach((form) => {
        form.reset();
    });
}

/**
 * opens a "Dialog" to intersect form submits
 * @param form The Form to intersect with
 * @param modal
 */
export function defaultButtonHandler(form, modal) {
    form.submit();
}

const defaultOkay = {handler: defaultButtonHandler, class: ['btn', 'btn-primary']};
const defaultDismiss = {type: 'dismiss', class: ['btn', 'btn-danger']};

(window as any).showSubmitDialog = showSubmitDialog
export function showSubmitDialog(dataElement: HTMLElement | object, title: string, msg:string, buttons: Record<string, any> = {"OK": defaultOkay, 'ablehnen': defaultDismiss}) {
    let submitModal = `
    <div class="modal fade" id="modalSubmitDialog" tabindex="-1" role="dialog" aria-labelledby="dialog center" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">${title}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true"></span>
            </button>
            </div>
            <div class="modal-body">
            ${msg}
            </div>
            <div class="modal-footer">
                <div id="btn-holder" class="d-flex justify-content-between w-100"></div>
            </div>
        </div>
        </div>
    </div>
    `;
    let old = document.getElementById('modalSubmitDialog');
    old ? old.remove() : {};

    let modalBody = document.createElement("div");
    document.body.appendChild(modalBody);
    modalBody.outerHTML = submitModal;


    let modal_element = document.getElementById('modalSubmitDialog') as HTMLElement;
    let dialogModal = new Modal(modal_element);

    modal_element.addEventListener("hidden.bs.modal", () => {
        modal_element.remove();
    });
    let btnholder = modal_element.querySelector('#btn-holder') as HTMLElement;

    Object.keys(buttons).forEach(key => {
        let button = document.createElement('button');
        button.innerHTML = key;
        button.addEventListener('click', () => {
            buttons[key].handler ? buttons[key].handler(dataElement, dialogModal) : {};
        });
        if (buttons[key].class instanceof Array) buttons[key].class.forEach((_class) => {
            button.classList.add(_class);
        })
        buttons[key].type === 'dismiss' ? (button.dataset['bsDismiss'] = 'modal') : {};
        btnholder.appendChild(button);
    })

    dialogModal.show();
}

export class ModalForm {
    modalName: string;
    modalEl: HTMLElement
    formName: string;
    submitName: string;
    action: string;
    submit: HTMLButtonElement;
    spinner: HTMLSpanElement;
    hiddenText: HTMLSpanElement;
    labelNodes: ChildNode[];

    isLoading = false;
    replaceId = null;
    eventListeners = {
        success: [],
        validationError: [],
        fatalError: [],
        requestError: [],
        fillFormData: [],
        shown: [],
        hidden: [],
        show: [],
        hide: []
    };

    constructor(modalName: string, formName: string, submitName: string, action: string) {
        this.modalName = modalName;
        this.modalEl = document.getElementById(this.modalName) as HTMLElement;
        this.formName = formName;
        this.submitName = submitName;
        this.action = action;

        this.submit = document.getElementById(formName + '_' + submitName) as HTMLButtonElement;

        this.spinner = document.createElement('span');
        this.spinner.classList.add('spinner-border', 'text-white');
        this.spinner.style.height = '1.5rem';
        this.spinner.style.width = '1.5rem';
        this.hiddenText = document.createElement('span');
        this.hiddenText.classList.add('visually-hidden');
        this.hiddenText.appendChild(document.createTextNode('Laden...'));
        this.labelNodes = [];

        this.submit.addEventListener('click', this.clickHandler.bind(this));
        this.modalEl.addEventListener('shown.bs.modal', args => this.fire('shown', args));
        this.modalEl.addEventListener('show.bs.modal', args => this.fire('show', args));
        this.modalEl.addEventListener('hidden.bs.modal', args => this.fire('hidden', args));
        this.modalEl.addEventListener('hide.bs.modal', args => this.fire('hide', args));

    }

    clickHandler(e) {
        e.preventDefault();
        if (this.isLoading) {
            return;
        }
        if (!(this.submit.form as HTMLFormElement).reportValidity()) {
            return false;
        }
        this.isLoading = true;

        while (this.submit.childNodes.length > 0) {
            this.labelNodes.push(this.submit.childNodes[0]);
            this.submit.removeChild(this.submit.childNodes[0]);
        }
        this.submit.appendChild(this.spinner);
        this.submit.appendChild(this.hiddenText);

        if (this.submit.form === undefined) {
            return;
        }

        let data = new FormData(this.submit.form as HTMLFormElement);
        data.set(this.submit.name, '');
        if (this.replaceId !== null)
            data.set('replace', this.replaceId);
        this.fire('fillFormData', data);

        return fetch(this.action, {method: 'POST', body: data})
            .then(res => res.json())
            .then(data => {
                this.hideErrors();

                if (data.status === 'success') {
                    window['closeModal'](this.modalName);
                    if (data['toast'] && (window as any).showToast) {
                        (window as any).showToast(data['toast']);
                    }
                    this.fire('success', data);
                } else if (data.status === 'error') {
                    if (data['toast'] && (window as any).showToast) {
                        (window as any).showToast(data['toast'], 'error');
                    }
                    this.displayErrors(data.errors);
                    this.fire('validationError', data);
                } else {
                    this.fire('fatalError', data);
                    // console.error(data);
                }
            })
            .catch(reason => {
                this.displayErrorPopover('Anfrage Fehlgeschlagen');
                this.fire('requestError', reason);
                // console.error('Request failed', reason);
            })
            .then(() => {
                this.isLoading = false;
                this.submit.removeChild(this.spinner);
                this.submit.removeChild(this.hiddenText);
                let node
                while (node = this.labelNodes.shift())
                    this.submit.appendChild(node);
            });
    }

    displayErrorPopover(message) {
        const popover = new Popover(this.submit, {
            trigger: 'manual',
            content: message
        });
        popover.show();
        const dismiss = () => {
            popover.hide();
            popover.dispose();
            document.body.removeEventListener('click', dismiss);
        }
        document.body.addEventListener('click', dismiss);
    }

    hideErrors() {
        const elements = this.submit.form?.getElementsByClassName('invalid-feedback')
        if (elements) {
            for (const el of elements) {
                el.classList.remove('d-block');
                while (el.childNodes.length > 0) {
                    el.removeChild(el.childNodes[0]);
                }
                if (!el.classList.contains('invalid-form-feedback')) {
                    el.previousElementSibling?.classList.remove('shadow-none', 'text-danger', 'border-danger');
                }
            }
        }
    }

    displayErrors(errors) {
        for (const name in errors) {
            if (errors[name].length === 0) {
                continue;
            }

            if (name === 'form') {
                const formErrorEl = this.submit.form?.querySelector('.invalid-form-feedback') as HTMLElement;
                formErrorEl.classList.add('d-block');
                for (const error of errors[name]) {
                    const msgEl = document.createElement('div');
                    msgEl.appendChild(document.createTextNode(error.message))
                    formErrorEl.appendChild(msgEl);
                }
                continue;
            }

            const errorEl = this.submit.form?.querySelector('.invalid-feedback[data-form-field="' + name + '"]') as HTMLElement;
            errorEl.classList.add('d-block');
            errorEl.previousElementSibling?.classList.add('shadow-none', 'text-danger', 'border-danger');
            for (const error of errors[name]) {
                const msgEl = document.createElement('div');
                msgEl.appendChild(document.createTextNode(error.message))
                errorEl.appendChild(msgEl);
            }
        }
    }

    replace(data) {
        const form = document.querySelector('[name="' + this.formName + '"]') as HTMLFormElement;
        const replaceCloseHandler = () => {
            form.removeAttribute('edited');
            this.replaceId = null;
            this.off('hide', replaceCloseHandler);
        }
        const replaceOpenHandler = () => {
            form.setAttribute('edited', "1");
            for (const key in data) {
                const el = document.getElementById(this.formName + '_' + key) as HTMLInputElement;
                if (el === null) {
                    continue;
                }
                el.value = data[key];
            }
            if (window.formCounterMap) {
                const formCounter = window.formCounterMap.get(this.formName);
                formCounter?.setFormData(data);
                formCounter ? formCounter.setCounterBoundaries() : void (0);
            }
            if (form.name === 'bhkw_out') {
                displayViewByInterfaceSelection(form.querySelector('#bhkw_out_bhkw'));
            }
            this.off('shown', replaceOpenHandler);
        }

        this.on('hide', replaceCloseHandler);
        this.on('shown', replaceOpenHandler);
        this.replaceId = data.id;

        openModal(this.modalName);
    }

    askDelete(id, el) {
        return new Promise((resolve, reject) => {
            const name = "Eintrag löschen";
            const classes = ['btn', 'btn-danger'];
            const buttons = {};

            let data = new FormData();
            data.set('delete', id);

            buttons[name] = {
                handler: (element, modal) => {
                    fetch(this.action, {method: "POST", body: data})
                        .then(response => response.json())
                        .then(data => {
                            if (data.status === 'success') {
                                data.element = element;
                                resolve(data);
                            } else {
                                data.element = element;
                                reject(data);
                            }
                        });
                    modal.hide();
                },
                class: classes
            };

            buttons["verwerfen"] = {
                class: ["btn", "btn-secondary"],
                handler: (element, modal) => {
                    modal.hide();
                    reject({status: 'aborted', element: element});
                },
            };
            showSubmitDialog(el, 'Eintrag löschen', 'Das Löschen des Eintrags kann nicht rückgängig gemacht werden.<br/><br/>Wollen Sie die gewählte Warenbewegung wirklich löschen?', buttons);
        });
    }

    on(event, listener) {
        this.eventListeners[event].push(listener);
        return this;
    }

    off(event, listener) {
        let idx = this.eventListeners[event].indexOf(listener);
        if (idx !== -1) {
            const n = [];
            for (const item of this.eventListeners[event]) {
                if (item !== listener) {
                    // @ts-expect-error
                    n.push(item)
                }
            }
            this.eventListeners[event] = n;
        }
        return this;
    }

    fire(event, args) {
        if (event == 'show') {
            if (args.target.id == 'modal-out') {
                if (window.formCounterMap) {
                    let bhkwOutMap = window.formCounterMap.get('bhkw_out') as CounterForm;
                    for (let [key, counter] of bhkwOutMap.getCounters()) {
                        counter.removeMessage();
                    }
                }
            }
        }

        for (const listener of this.eventListeners[event]) {
            listener(args);
        }
    }
}

window['ModalForm'] = ModalForm;


window.addEventListener('load', () => {
    for (let el of document.getElementsByClassName('open-modal-btn')) {
        el.addEventListener('click', function () {
            // @ts-expect-error
            window['openModal'](this.getAttribute('data-modal'));
        });
    }
    for (let el of document.getElementsByClassName('close-modal-btn')) {
        el.addEventListener('click', function () {
            // @ts-expect-error
            window['closeModal'](this.getAttribute('data-modal'));
        });
    }
});

(() => {
    let old_fetch = fetch;
    window["fetch"] = async function (...args) {
        let promise = old_fetch(...args);
        promise.then(res => {
            if (res.redirected) {
                if (new URL(res.url).pathname === "/login") {
                    // @ts-expect-error
                    window.location = "/login?errorCode=1";
                }
                if (new URL(res.url).pathname === "/verwaltung") {
                    // @ts-expect-error
                    window.location = "/verwaltung?errorCode=switchUserLoggedOut";
                }
                if (new URL(res.url).pathname === "/verwaltung/benutzer") {
                    // @ts-expect-error
                    window.location = "/verwaltung/benutzer?errorCode=switchUserLoggedOut&opened=ROLE_BIO_PLANT";
                }
            }
        })
        return promise;
    }
})();

let errorNode;
let errorElem;
let errorText = '';

let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new Tooltip(tooltipTriggerEl)
});


export function checkPassword(elem) {
    let noUpper = true;
    let noLower = true;
    let noNumber = true;
    let noSpecial = true;
    let errorMsg = '';

    errorElem = document.getElementById("passwordErrorMessage");
    if (errorElem !== null) {
        errorElem.parentNode.removeChild(errorElem);
    }

    if (/[$-*+/_!?=@()\.]/.test(elem.value)) {
        noSpecial = false;
    }
    if (/[0-9]/.test(elem.value)) {
        noNumber = false;
    }
    if (/[A-ZÄÖÜ]/.test(elem.value)) {
        noUpper = false;
    }
    if (/[a-zäöü]/.test(elem.value)) {
        noLower = false;
    }

    if (elem.length < 8 || noSpecial || noNumber || noUpper || noLower) {
        if (noUpper) {
            errorMsg += (errorMsg.length ? ', ' : '') + 'Grossbuchstaben';
        }
        if (noLower) {
            errorMsg += (errorMsg.length ? ', ' : '') + 'Kleinbuchstaben';
        }
        if (noNumber) {
            errorMsg += (errorMsg.length ? ', ' : '') + 'Zahlen';
        }
        if (noSpecial) {
            errorMsg += (errorMsg.length ? ', ' : '') + 'Sonderzeichen';
        }
        if (elem.value.length < 8) {
            errorMsg += (errorMsg.length ? ', ' : '') + 'mindestens 8 Zeichen';
        }

        if (errorMsg.length) {
            errorMsg = 'Ihr Passwort muss ' + errorMsg + ' enthalten.';
        }

        errorNode = document.createElement("div");
        errorNode.appendChild(document.createTextNode(errorMsg));
        errorNode.classList.add('small', 'bg-yellow', 'text-danger');
        errorNode.id = "passwordErrorMessage";
        elem.parentElement.append(errorNode);
        return false;
    }
    errorText = '';
    return false;
}

function checkPasswordMatch(elem) {
    let passwordFirst = document.getElementById(elem.id.replace('second', 'first')) as HTMLInputElement

    errorElem = document.getElementById("passwordErrorMessage");
    if (errorElem !== null) {
        errorElem.parentNode.removeChild(errorElem);
    }
    if (passwordFirst.value !== elem.value) {
        errorNode = document.createElement("div");
        errorNode.appendChild(document.createTextNode('Die Passwörter stimmen nicht überein. Bitte wiederholen Sie Ihr Passwort'));
        errorNode.classList.add('small', 'bg-yellow', 'text-danger');
        errorNode.id = "passwordErrorMessage";
        passwordFirst.parentElement?.append(errorNode);
        return false;
    }
    errorText = '';
    return false;
}

function checkRegistration(elem, event) {

    stopEvent(event);

    if (errorText === '') {
        let form = elem.closest('form');
        if (!form[0].reportValidity())
            return;

        checkPassword(form[0].querySelector('input[type="password"][id*="first"]'));
        if (errorText !== '')
            return;

        checkPasswordMatch(form[0].querySelector('input[type="password"][id*="second"]'));
        if (errorText !== '')
            return;

        form.submit();
    }
}

function submitModalForm(button) {

    let modalDialog = button.closest('.modal.fade');
    let form = modalDialog.find('form');
    form.submit();
    form.find('input').val('');
}

export function loadingData() {
    let spinner = $("#loadingData");
    let warenbewegung = $("#warenbestandsWrapper");
    let visible = spinner.hasClass('visually-hidden');

    if (visible) {
        spinner.removeClass('visually-hidden');
        warenbewegung.addClass('visually-hidden');
        return false;
    }
    spinner.addClass('visually-hidden');
    warenbewegung.removeClass('visually-hidden');
    return false;
}

function getNumberFromString(string) {
    let number = string.replace(/[^\d,-]/g, '');
    if (/\,/.test(number)) {
        return parseFloat(number);
    }
    return parseInt(number);
}